<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Inspection/Audit Template</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form #form="ngForm" (ngSubmit)="onSubmit()">

  <hr class="m-0 p-0">

  <mat-dialog-content class="p-3 py-4">

    <mat-form-field style="width: 100%" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Inspection/Audit Template</mat-label>
      <input
        matInput
        placeholder="Inspection/Audit Template"
        [(ngModel)]="audit.name"
        name="name"
        type="text"
        required
        #name />
      <mat-hint>Please enter an Inspection/Audit template name. </mat-hint>
    </mat-form-field>

  </mat-dialog-content>

  <hr class="m-0 p-0">

  <mat-error class="px-3 pt-3 pb-0" *ngIf="!audit.item_ids?.length">Please select questions to Inspection or Audit. </mat-error>

  <mat-dialog-actions class="px-3 py-2">

    <button
      mat-raised-button
      [disabled]="!form.valid || !audit.item_ids?.length || inProgress"
      color="primary"
      type="submit"
      class="save my-2 ml-1 mr-2">
      <mat-icon>save</mat-icon>
      Save
    </button>

    <button
      mat-raised-button
      (click)="onSelectAuditItems()"
      [matBadge]="audit.item_ids?.length ?? 0"
      type="button"
      class="my-2 ml-1 mr-2"
      color="secondary">
      <mat-icon>list</mat-icon>
      Questions
    </button>

    <button mat-icon-button class="dialog-remove-button my-2 ml-auto mr-1" color="warn" *ngIf="audit.id">
      <mat-icon>delete</mat-icon>
    </button>

  </mat-dialog-actions>

</form>
